<div class="container-fluid middle content-main">
  <div class="row align-items-center">
    <div class="col mx-auto">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<nav class="navbar fixed-bottom reserve-bottom-bar" [class.checkout-bottom-bar]="showPaymentBt" [class.bg-primary]="!showPaymentBt">
  <div class="container nav-reserve-bottom">
    @if (showPreviousBt) {
      <button class="nav-link btn btn-outline-neutral btn-lg btn-reserve-back" (click)="goBack()" [attr.aria-label]="'bt.back'|traduccion">
        <i class="nc-icon nc-minimal-left" aria-hidden="true"></i>&nbsp;{{'bt.back'|traduccion}}
      </button>
    }
    @if (showPaymentBt) {
      <div class="checkout-bar-total"><span>{{'checkout.total'|traduccion}}</span><strong>{{checkoutTotal}}€</strong></div>
    }
    <div class="ml-md-auto btn-reserve-pay">
      <div class="c-bt-next">
        @if (showNextBt) {
          <button class="nav-link btn btn-outline-neutral btn-lg" [class.disabled]="!enabledNextBt" [disabled]="!enabledNextBt"
            (click)="clickCallNext('callNext')">{{nameNextBt}}&nbsp;
            <i class="nc-icon nc-minimal-right" aria-hidden="true"></i>
          </button>
        }
      </div>

      <div class="c-bt-pay">
        @if (showPaymentBt) {
          <button (click)="payForReservation()" class="btn btn-lg checkout-pay-button">
            <i class="nc-icon nc-lock-circle-open" aria-hidden="true"></i>
            {{showPaymentFreeBt ? ('bt.getFree'|traduccion) : ('checkout.pay'|traduccion)}} {{showPaymentFreeBt ? '' : checkoutTotal + '€'}}
            <i class="nc-icon nc-minimal-right" aria-hidden="true"></i>
          </button>
        }
      </div>
    </div>
  </div>
</nav>
